var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 27,
    viewBox: "0 0 133 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7797 26.8798L8.93678 6.1416L0 27H28.3815L23.095 14.6616L17.7797 26.8798Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 11.4886L17.7807 20.6961L10.2405 3.09594L11.5669 0L17.7797 14.4977L20.4066 8.38919L21.7344 11.4886Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1642 17.3426L45.873 5.45706H45.127L40.8358 17.3426H50.1642ZM42.5149 1H48.4852L58 27H53.7088L51.47 20.871H39.53L37.2912 27H33L42.5149 1Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27H65V1H61V27Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69 9H72.5555V19.5886C72.5555 21.8826 74.3688 23.8238 76.8221 23.8238C79.4888 23.8238 81.4445 21.8826 81.4445 19.5886V9H85V26.6474H81.8L81.4445 24.8823H81.2667C80.8755 25.271 80.4488 25.6235 79.9512 25.9412C79.0979 26.4706 77.7821 27 76.1112 27C71.8445 27 69 24.2117 69 19.5886V9Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.327 17.4788C103.327 13.6704 100.939 11.2535 98.0001 11.2535C95.0613 11.2535 92.6734 13.6704 92.6734 17.4788C92.6734 21.2872 95.0613 23.7045 98.0001 23.7045C100.939 23.7045 103.327 21.2872 103.327 17.4788ZM103.327 24.4365H103.143C102.592 25.1692 100.976 27 97.4491 27C92.6368 27 89 23.3379 89 17.4788C89 11.6197 92.6368 7.95771 97.4491 7.95771C101.012 7.95771 102.519 9.82531 103.143 10.5215H103.327V1H107V26.6342H103.694L103.327 24.4365Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.51 16.0384C125.106 13.1154 123.123 11.1061 120.184 11.1061C117.061 11.1061 115.224 13.1154 114.673 16.0384H125.51ZM128.449 21.3369C127.567 23.7118 124.959 27 120.184 27C114.857 27 111 23.1638 111 17.5C111 11.8365 114.857 8 120.184 8C125.143 8 129 11.8365 129 16.9523C129 17.5 128.927 17.9384 128.89 18.2673L128.817 18.7792H114.673C115.078 21.8845 117.245 23.8941 120.184 23.8941C122.388 23.8941 124.004 22.6153 124.592 21.3369H128.449Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogo);
export default __webpack_public_path__ + "static/media/BlackLogo.36885626e165598100d577eb61bcaa2f.svg";
export { ForwardRef as ReactComponent };